import { createContext, useContext, useEffect, useState } from 'react';
import { authService } from '../services';
import { campaignService } from '../services';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [activeCampaign, setActiveCampaign] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    const restoreSession = async () => {
      if (!authService.hasSession()) {
        if (mounted) setIsLoading(false);
        return;
      }
      try {
        const response = await authService.getCurrentUser();
        if (mounted) setUser(response.data);
      } catch {
        if (mounted) setUser(null);
      } finally {
        if (mounted) setIsLoading(false);
      }
    };
    const expireSession = () => setUser(null);
    window.addEventListener('votum:session-expired', expireSession);
    restoreSession();
    return () => {
      mounted = false;
      window.removeEventListener('votum:session-expired', expireSession);
    };
  }, []);

  useEffect(() => {
    if (!user || user.must_change_password) {
      setActiveCampaign(null);
      return undefined;
    }
    let mounted = true;
    campaignService.getActive()
      .then((response) => mounted && setActiveCampaign(response.data))
      .catch(() => mounted && setActiveCampaign(null));
    return () => { mounted = false; };
  }, [user]);

  const login = async (username, password) => {
    const response = await authService.login(username, password);
    setUser(response.data);
    return response.data;
  };
  const logout = async () => {
    try {
      await authService.logout();
    } finally {
      setUser(null);
      setActiveCampaign(null);
    }
  };
  const changePassword = async (values) => {
    const response = await authService.changePassword(values);
    setUser(response.data.user);
    return response.data.user;
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        activeCampaign,
        isAuthenticated: Boolean(user),
        isLoading,
        login,
        changePassword,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth debe utilizarse dentro de AuthProvider');
  }
  return context;
}
